import { ReactRenderer, RendererAppearance } from '@atlaskit/renderer';
import { css } from '@emotion/react';
import { useDocumentStorage } from '../providers/document-storage';
import { BreadcrumbActions } from './BreadcrumbActions';
import { EditorAppearance } from '@atlaskit/editor-core/editor';

interface RendererProps {
  setMode?: (mode: boolean) => void;
}

const titleContainer = (appearance: EditorAppearance) => css`
  margin: ${appearance === 'full-width' ? '0 0 20px 0' : 'auto auto 20px auto'};

  max-width: ${appearance === 'full-width' ? '100%' : '760px'};
`;

const titleText = css`
  font-weight: normal;
  font-size: 28px;
  line-height: 1.25;
`;

const renderContainer = css`
  padding: 32px;
`;

export const Renderer = ({ setMode }: RendererProps) => {
  const { document, title, appearance } = useDocumentStorage();

  return (
    <div css={renderContainer}>
      <BreadcrumbActions appearance={appearance} toggleEditMode={setMode} />
      <div>
        <div css={titleContainer(appearance)}>
          <h1 css={titleText}>{title ?? 'New document'}</h1>
        </div>
        <ReactRenderer
          allowHeadingAnchorLinks
          allowAltTextOnImages
          allowColumnSorting
          adfStage="stage0"
          // dataProviders={providerFactory}
          // extensionHandlers={extensionHandlers}
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          document={document as any}
          appearance={appearance as RendererAppearance}
          // media={{
          //   featureFlags: mediaFeatureFlags
          // }}
          // allowCustomPanels={props.allowCustomPanel}
          eventHandlers={{
            onUnhandledClick: setMode
              ? () => {
                  setMode(true);
                }
              : undefined
          }}
        />
      </div>
    </div>
  );
};
